import React from 'react';
import { IconSvgProps } from '@models/common';

const Upload: React.FC<IconSvgProps> = (props) => {
  const { size = 32, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='currentColor'>
      <path
        fillRule='evenodd'
        d='M15.3 21.13a1 1 0 0 1 1.4 0l2.67 2.66a1 1 0 1 1-1.41 1.42l-.96-.96v5.58a1 1 0 0 1-2 0v-5.58l-.96.96a1 1 0 1 1-1.41-1.42l2.66-2.66Z'
        clipRule='evenodd'
      />
      <path d='M16.63 5.5a6.57 6.57 0 0 0-6.37 8.3c.67.2 1.29.48 1.85.86a1 1 0 1 1-1.1 1.66 4.72 4.72 0 0 0-2.63-.78 4.68 4.68 0 0 0-4.71 4.65c0 2.55 2.1 4.64 4.71 4.64a1 1 0 0 1 0 2 6.68 6.68 0 0 1-6.71-6.64c0-3.61 2.89-6.53 6.48-6.65A8.57 8.57 0 0 1 16.63 3.5c4.22 0 7.73 3 8.48 6.96a8.53 8.53 0 0 1 5.22 7.84c0 4.1-2.91 7.51-6.79 8.34a1 1 0 1 1-.42-1.95 6.55 6.55 0 0 0 5.21-6.39 6.54 6.54 0 0 0-6.62-6.53c-.77 0-1.52.14-2.2.38a1 1 0 0 1-.66-1.9c1.29-.44 2.67-.58 4.03-.4a6.62 6.62 0 0 0-6.25-4.35Z' />
    </svg>
  );
};

export default Upload;
